import { useEffect, useState } from 'react';

import { getTrustedFunnel } from '@web-platform/shared-universal-redux/src/state';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { buildImpressionEvent, buildInteractionEvent } from './utils/buildEvent';
import { sendEvent, sendEventWithDebounce } from './utils/sendEvent';

import type { ComponentTrackingConfig } from '@web-platform/shared-universal-types-tracking/src/MBDTypes';

export const useBehaviourTracking = <Wrapper extends HTMLElement>(
  config: ComponentTrackingConfig,
) => {
  const [elementRef, setElementRef] = useState<Wrapper | null>(null);
  const { viewGuid } = useSelector(getTrustedFunnel);

  useEffect(() => {
    if (!elementRef) return undefined;

    const cleanup = {
      onClick: () => {},
    };

    requestAnimationFrame(() => {
      const impressionGuid = uuid();
      const onClick = () => {
        sendEvent(buildInteractionEvent(impressionGuid, config));
      };
      cleanup.onClick = onClick;
      sendEventWithDebounce(buildImpressionEvent(viewGuid, config), impressionGuid);
      elementRef.addEventListener('click', onClick);
    });

    return () => {
      elementRef.removeEventListener('click', cleanup.onClick);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef]);

  return {
    ref: setElementRef,
  };
};
